export const NON_RATED_INDIVIDUALS_SCROLL_TARGET = 'removedDrivers';
